<template>
	<div class="tp-DailyReport">
		<ui-bottom-sheet ref="editSheet" actions>
			<!-- actions -->
			<div slot="actions" class="right">
				<el-button :loading="loading" @click="show(false)">Fechar</el-button>
				<el-button @click="printElem">Imprimir</el-button>
			</div>

			<!-- field to select the date -->
			<el-date-picker
				v-model="selectedDate"
				type="date"
				placeholder="Escolha um dia"
			/>

			<div id="toPrint">
				<DailyReportTableReact
					:newSales="newSales"
					:usedSales="usedSales"
					:isLoading="loading"
					:profit="profit"
				/>
			</div>
		</ui-bottom-sheet>
	</div>
</template>

<script>
import { mapGetters } from "vuex";
import ReactInVue from "@/components/logic/wrappers/ReactInVue";
import { DailyReportTable } from "@/modules/material/components/DailyReportTable";

const DailyReportTableReact = ReactInVue(DailyReportTable);

export default {
	components: {
		DailyReportTableReact,
	},

	data() {
		return {
			newSales: [],
			usedSales: [],

			loading: false,

			selectedDate: new Date(),
		};
	},

	computed: {
		...mapGetters(["configs"]),

		profit() {
			const value = this.configs.find((item) => item.key === "profit").value;
			return Number.parseFloat(value);
		},
	},

	watch: {
		selectedDate: {
			immediate: true,
			handler(selectedDate) {
				// enable loading
				this.loading = true;

				this.$stellar
					.action("salesByDay", {
						selectedDate,
						onlyBilled: true,
					})
					.then((res) => {
						this.newSales = res.new;
						this.usedSales = res.used;

						// disabled loading
						this.loading = false;

						// recompute the bootom sheet size
						this.$nextTick((_) => {
							this.$refs.editSheet.adjustSize();
						});
					});
			},
		},
	},

	methods: {
		/**
		 * Change the visibility of the component.
		 *
		 * @type {[type]}
		 */
		show(val = true) {
			this.$refs.editSheet.show(val);
		},
		/** @argument
		 * print daly report
		 */
		printElem() {
			this.requestVisibility = false;
			const mywindow = window.open("", "PRINT", "height=400,width=600");
			mywindow.document.write(`<html><head><title>${document.title}</title>`);

			mywindow.document.write("</head><body >");
			mywindow.document.write(`<h1>${document.title}</h1>`);
			mywindow.document.write(document.getElementById("toPrint").innerHTML);
			mywindow.document.write("</body></html>");

			mywindow.document.close(); // necessary for IE >= 10
			mywindow.focus(); // necessary for IE >= 10*/

			mywindow.print();
			mywindow.close();
		},
	},
};
</script>

<style lang="scss">
.tp {
	&-DailyReport {
		&__title {
			font-size: 1.3em;
			margin: 10px 0;
		}
	}
}
</style>
